import React from 'react';
import {Field, reduxForm} from 'redux-form';
import SubmitButton from '../common/SubmitButton';
import ValidatedWrappedInputField from "../company/information/ValidatedWrappedInputField";
import {DepartmentValidator} from "./DepartmentsValidator";
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import afterSubmitFail from '../common/form/focusAfterSubmitFail';
import ResetButton from "../common/ResetButton";

class DepartmentForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit} noValidate={true}>
                <Field
                    className="form-control"
                    name="name"
                    type="text"
                    component={ValidatedWrappedInputField}
                    label={this.props.intl.formatMessage(messages.name)}
                />
                <Field
                    className="form-control"
                    name="sorter"
                    type="number"
                    min="1"
                    component={ValidatedWrappedInputField}
                    label={this.props.intl.formatMessage(messages.order)}
                />
                <div className="form-group row">
                    <div className="col-sm-12">
                        <div className="offset-sm-2">
                            <SubmitButton isUpdate={this.props.isUpdate}/>
                            <ResetButton onClick={this.props.handleReset}/>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

DepartmentForm = reduxForm({
    form: 'department',
    validate: DepartmentValidator,
    onSubmitFail: afterSubmitFail
})(DepartmentForm);

export default injectIntl(DepartmentForm);


// WEBPACK FOOTER //
// ./web/src/components/departments/DepartmentForm.jsx